export default __webpack_public_path__ + "static/media/B0002.e3b505a8.png";